export const footerData = {
  logo: "ASCENCIO",
  tagline:
    "Strategic marketing for Aesthetic Clinics ready to scale beyond word-of-mouth.",
  sections: [
    {
      title: "Quick Links",
      links: [
        { text: "Home", path: "/" },
        { text: "Services", path: "/services" },
        { text: "How It Works", path: "/how-it-works" },
        { text: "Contact", path: "/contact" },
      ],
    },
    {
      title: "Services",
      links: [
        { text: "Lead Generation", path: "/services#lead-generation" },
        { text: "Social Media Management", path: "/services#social-media" },
        { text: "Marketing Automations", path: "/services#automations" },
        { text: "Website Design", path: "/services#website" },
      ],
    },
    {
      title: "Contact",
      links: [
        {
          text: "info@ascencio.co.uk",
          path: "mailto:info@ascencio.co.uk",
          iconName: "Mail",
        },
        {
          text: "+1 (662) 493-4617", // TODO: replace with UK +44 number
          path: "tel:+16624934617", // TODO: replace with UK +44 number
          iconName: "Phone",
        },
        {
          text: "London, UK",
          path: "#",
          iconName: "MapPin",
        },
      ],
    },
  ],
  social: [
    {
      name: "Instagram",
      url: "https://www.instagram.com/ascenciogroup.uk/?utm_source=ig_web_button_share_sheet",
      iconName: "Instagram",
    },
    {
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/ascencio-group/",
      iconName: "Linkedin",
    },
    {
      name: "Facebook",
      url: "#", // TODO: add Facebook page URL
      iconName: "Facebook",
    },
  ],
  copyright: "© 2026 ASCENCIO Group. All rights reserved.",
  legal: [
    { text: "Privacy Policy", path: "/privacy" },
    { text: "Terms of Service", path: "/terms" },
    // TODO: Add Companies House number: Registered in England & Wales No. XXXXXXXX
    // TODO: Add ICO Registration No. XXXXXXXX
  ],
};
